/**
 * Şirket modüllerinin tek kaynağı. Daha önce hem NewCompany hem
 * CompaniesUpdateForm içinde ayrı ayrı yazılıydı.
 *
 * `offConsequence`: modül kapatılırken onay ekranında gösterilen, geri
 * alınamayan yan etkiyi anlatan metin. Yoksa yalnızca "panelde görünmeyecek"
 * anlamına gelir.
 */
export interface CompanyModule {
  label: string;
  key: string;
  offConsequence?: string;
}

export const COMPANY_MODULES: CompanyModule[] = [
  { label: "Takvim", key: "isCalendarAvailable" },
  // "Genel Ayarlar Mesai Saati" KALDIRILDI (plan 2.30): açtığı ekran
  // `company.workHours` yazıyordu, onu da ölçüt zinciri hiç okumuyordu.
  // Şirket geneli çalışma düzeni artık departmansız vardiya tanımı (plan 2.24).
  // "Departman Ayarlar Mesai Saati" KALDIRILDI (plan 2.35): açtığı ekran
  // departmanın `workHours`'ını yazıyordu. Kullanıcı kararıyla departman
  // çalışma düzeni taşımayı bıraktı; ölçüt vardiya atamasından geliyor.
  // 2.30'daki `company.workHours` bayrağıyla aynı akıbet.
  { label: "Döküman/Belge Yükleme Modülü", key: "isDocumentUploadAvailable" },
  { label: "CV/Başvuran Modülü", key: "isApplicantAvailable" },
  {
    label: "BLE ile Kapı Açma",
    key: "isBleAvailable",
    offConsequence:
      "Şirketin kayıtlı konum/geofence ayarı kalıcı olarak silinecek ve " +
      "personelin mobil uygulamadaki 'Cebindeyken Aç' ile 'Konum Bazlı Aktif Et' " +
      "tercihleri kapatılacak.",
  },
  { label: "Misafir/TOTP Erişimi", key: "isGuestAccessAvailable" },
];
